const prefix = "link-";

export default function linkUid(id) {
	return `${prefix}${id}`;
}

export function isLinkUid(uid) {
	return typeof uid === "string" && uid.startsWith(prefix);
}
